'use client';

import { useTranslations } from 'next-intl';
import { Globe } from 'lucide-react';
import { LOCALE_CONFIG, LOCALES, isSupportedLocale } from '@/contexts/i18n/utils';
import { useHomeLanguage } from '@/contexts/i18n/navigation';

interface LanguageSwitcherProps {
  className?: string;
  trackingButtonId?: string;
  trackingButtonScreen?: string;
  trackingAction?: string;
}

export function LanguageSwitcher({
  className,
  trackingButtonId,
  trackingButtonScreen,
  trackingAction,
}: LanguageSwitcherProps) {
  const { locale, isPending, switchLanguage } = useHomeLanguage();
  const t = useTranslations('languageSwitcher');

  return (
    <div className={`relative inline-flex items-center gap-1.5 ${className ?? ''}`}>
      <Globe aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
      <select
        value={locale}
        aria-label={t('label')}
        aria-busy={isPending}
        disabled={isPending}
        onChange={(e) => { if (isSupportedLocale(e.target.value)) switchLanguage(e.target.value); }}
        className="appearance-none bg-transparent text-sm text-muted-foreground cursor-pointer hover:text-foreground transition-colors focus:outline-none"
        data-landing-button-id={trackingButtonId}
        data-landing-button-screen={trackingButtonScreen}
        data-landing-action={trackingAction}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_CONFIG[code].label}
          </option>
        ))}
      </select>
    </div>
  );
}
